import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * A wrapper component that adds click functionality to show user bio
 * Can wrap any user name, avatar, or other user-related element
 * 
 * Usage:
 * <UserBioTrigger 
 *   userId="user123" 
 *   userName="John Doe" 
 *   userEmail="john@example.com"
 *   onShowBio={showUserBio}
 * >
 *   <span className="user-name">John Doe</span>
 * </UserBioTrigger>
 */
const UserBioTrigger = ({ 
  children, 
  userId, 
  userName, 
  userEmail, 
  onShowBio,
  disabled = false
}) => {
  const { t } = useLanguage();

  const handleContextMenu = (e) => {
    // Still support right-click as a secondary option
    if (disabled || !onShowBio || !userId) return;
    
    e.preventDefault();
    onShowBio(userId, userName, userEmail);
  };

  const handleClick = (e) => {
    // Primary click method - now enabled by default
    if (disabled || !onShowBio || !userId) return;
    
    e.preventDefault();
    e.stopPropagation(); // Prevent event bubbling
    onShowBio(userId, userName, userEmail);
  };

  if (!userId || !onShowBio) {
    // Return children without functionality if required props are missing
    return children;
  }

  return (
    <span
      onContextMenu={handleContextMenu}
      onClick={handleClick}
      style={{
        cursor: disabled ? 'default' : 'pointer',
        userSelect: 'none'
      }}
      title={disabled ? undefined : t('userBio.clickToView', { name: userName || userEmail || 'user' })}
    >
      {children}
    </span>
  );
};

export default UserBioTrigger;